export const AdminPermissions = {
  Dashboard: 'admin_dashboard',
  ListUsers: 'list_users',
  UpdateUser: 'update_users',
  LoginAsClient: 'login_as_client',
  ListCompanies: 'list_companies',
  CreateCompany: 'create_company',
  UpdateCompany: 'update_company',
  ListCandidates: 'list_candidates',
  ProcessCandidateChecks: 'process_candidate_checks',
  ListCandidateChecks: 'list_candidate_checks',
  ListCheckTypes: 'list_check_types',
  UpdateCheckType: 'update_check_type',
  ListPricing: 'list_pricing',
  UpdatePricing: 'update_pricing',
  ListCost: 'list_cost',
  ListAdminUsers: 'list_admin_users',
  Reporting: 'reporting',
  AdminLogs: 'admin_logs',
  ManageAdminUsers: 'manage_admin_users',
  ProcessACIC: 'process_acic',
  UpdateEmailTemplates: 'update_email_templates',
};

export const AdminPermissionsDetails = {
  [AdminPermissions.UpdateCheckType]: {
    name: 'Update Check Type',
    description: 'Ability to update check types support users',
    slug: AdminPermissions.UpdateCheckType,
  },
  [AdminPermissions.Dashboard]: {
    name: 'Dashboard',
    description: 'Ability to access admin dashboard',
    slug: AdminPermissions.Dashboard,
  },
  [AdminPermissions.ListUsers]: {
    name: 'List Users',
    description: 'Ability to list all Checkmate users',
    slug: AdminPermissions.ListUsers,
  },
  [AdminPermissions.ProcessCandidateChecks]: {
    name: 'Process Candidate Checks',
    description: 'Ability to process candidate checks',
    slug: AdminPermissions.ProcessCandidateChecks,
  },
  [AdminPermissions.ListCompanies]: {
    name: 'List Companies',
    description: 'Ability to list all Checkmate companies',
    slug: AdminPermissions.ListCompanies,
  },
  [AdminPermissions.ListCandidates]: {
    name: 'List Candidates',
    description: 'Ability to list all Checkmate candidates',
    slug: AdminPermissions.ListCandidates,
  },
  [AdminPermissions.ListCandidateChecks]: {
    name: 'List Candidate Checks',
    description: 'Ability to list all Checkmate candidate checks',
    slug: AdminPermissions.ListCandidateChecks,
  },
  [AdminPermissions.ListCheckTypes]: {
    name: 'List Check Types',
    description: 'Ability to list all Checkmate check types',
    slug: AdminPermissions.ListCheckTypes,
  },
  [AdminPermissions.ListPricing]: {
    name: 'List Pricing',
    description: 'Ability to view the pricing page (check types, provider, prices)',
    slug: AdminPermissions.ListPricing,
  },
  [AdminPermissions.UpdatePricing]: {
    name: 'Update Pricing',
    description: 'Ability to edit check type pricing and export company checks pricing report',
    slug: AdminPermissions.UpdatePricing,
  },
  [AdminPermissions.ListCost]: {
    name: 'List Cost',
    description: 'Ability to see cost column on pricing table and cost-related fields in reports',
    slug: AdminPermissions.ListCost,
  },
  [AdminPermissions.Reporting]: {
    name: 'Reporting',
    description: 'Ability to access admin reporting',
    slug: AdminPermissions.Reporting,
  },
  [AdminPermissions.ListAdminUsers]: {
    name: 'List Admin Users',
    description: 'Ability to list all admin users',
    slug: AdminPermissions.ListAdminUsers,
  },
  [AdminPermissions.AdminLogs]: {
    name: 'Admin Logs',
    description: 'Ability to see admin logs',
    slug: AdminPermissions.AdminLogs,
  },
  [AdminPermissions.LoginAsClient]: {
    name: 'Login Into Clients',
    description: 'Ability to login into clients',
    slug: AdminPermissions.LoginAsClient,
  },
  [AdminPermissions.UpdateUser]: {
    name: 'Update Users',
    description: 'Ability to update/delete users',
    slug: AdminPermissions.UpdateUser,
  },
  [AdminPermissions.CreateCompany]: {
    name: 'Create Company',
    description: 'Ability to create companies',
    slug: AdminPermissions.CreateCompany,
  },
  [AdminPermissions.UpdateCompany]: {
    name: 'Update Company',
    description: 'Ability to update companies',
    slug: AdminPermissions.UpdateCompany,
  },
  [AdminPermissions.ManageAdminUsers]: {
    name: 'Manage Admin Users',
    description: 'Ability to add and edit admin permissions for users',
    slug: AdminPermissions.ManageAdminUsers,
  },
  [AdminPermissions.ProcessACIC]: {
    name: 'Process ACIC',
    description: 'Ability to process ACIC',
    slug: AdminPermissions.ProcessACIC,
  },
  [AdminPermissions.UpdateEmailTemplates]: {
    name: 'Update Email Templates',
    description: 'Ability to update default email templates for candidates and referees',
    slug: AdminPermissions.UpdateEmailTemplates,
  },
};
